"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStylesSelectsInFilter = void 0;
var core_1 = require("@material-ui/core");
var styleObjs_1 = require("../../../styles/styleObjs");
exports.useStylesSelectsInFilter = core_1.makeStyles(function (theme) { return (__assign({ root: {
        position: 'absolute',
        zIndex: 20202,
        width: '100%',
        // maxWidth: 400,
        backgroundColor: '#fff',
    }, selects: {
        maxHeight: 400,
        padding: theme.spacing(1),
        overflow: 'auto',
    } }, styleObjs_1.clickBG)); });
